import { render, staticRenderFns } from "./ModalShowMultipleDocuments.vue?vue&type=template&id=8c851908&"
import script from "./ModalShowMultipleDocuments.vue?vue&type=script&lang=js&"
export * from "./ModalShowMultipleDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports